import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {
  StatusEventPageActionsParameters
} from '@models/machine/status-event-signal/status-event-page-actions-parameters';

@Injectable({
  providedIn: 'root'
})
export class StatusEventPageActionsQueueService {
  private statusEvensActionsBroker = new Subject<StatusEventPageActionsParameters>();

  public getStatusEventActionsSubject(){
    return this.statusEvensActionsBroker;
  }

  public dispatch(event: StatusEventPageActionsParameters): void {
    this.statusEvensActionsBroker.next(event);
  }
}
